import React, { useEffect, useState } from 'react';

import { Box, Col, Row } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useRouter } from 'next/router';

import { useObservability } from '../../../../helpers/observability';

// Read UTM params from window.location instead of router.query because
// the Cloudflare Worker strips UTM params from the SSR cache key (COSMOS_PARAM_DENYLIST),
// so they are never present in __NEXT_DATA__.query.
const isSellerReferral = (): boolean => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('utm_source') === 'seller' && params.get('utm_campaign') === 'ae_pdp';
};

export const RentalScamBanner: React.FC = () => {
  const router = useRouter();
  const { trackJourneyEvent } = useObservability();
  const [visible, setVisible] = useState(false);
  const addressUuid = Array.isArray(router.query.address_id)
    ? router.query.address_id[0]
    : (router.query.address_id ?? '');

  useEffect(() => {
    setVisible(isSellerReferral());
  }, []);

  useEffect(() => {
    if (!visible) return;
    trackJourneyEvent('marketplaceProperty', 'rentalScamBannerView', {
      addressUuid,
    });
  }, [visible, addressUuid, trackJourneyEvent]);

  if (!visible) return null;

  return (
    <Col className="pb-4">
      <Row className="items-start gap-2 rounded-2xl bg-od-bg-error-secondary p-4">
        <Box className="shrink-0">
          <IconExclamationCircle size={16} color="var(--color-od-content-error)" />
        </Box>
        <Col className="flex-1 gap-1">
          <Text as="span" className="text-label-sm text-od-content-error">
            This home is not for rent
          </Text>
          <Text as="span" className="text-body-sm text-od-content-error">
            If someone asked you to pay a deposit or rent for this home, you may be the target of a
            scam. Opendoor does not rent homes.{' '}
            <Link
              href="/rental-scam"
              analyticsName="rental-scam-banner-learn-more"
              className="text-body-sm text-od-content-error underline"
              onClick={() => {
                trackJourneyEvent('marketplaceProperty', 'rentalScamBannerLearnMore', {
                  addressUuid,
                });
              }}
            >
              Learn more
            </Link>
          </Text>
        </Col>
      </Row>
    </Col>
  );
};
